import React from 'react'
import { I18n, CDNSVG } from '@front/volcanion'

import { Grid, Box } from '@mui/material'
import { TextField } from '@front/squirtle'

const DEFAULT_TRANSLATIONS = [
  { name: 'name_trkey', labelKey: 'name.label.one', xs: 3, required: true },
  { name: 'description_trkey', labelKey: 'description.label.one', xs: 6, required: true }
]

const Row = ({ lang, index, translations = DEFAULT_TRANSLATIONS }) =>
  <Grid container spacing={1} alignItems='center' size={12}>
    <Grid hidden={lang !== 'fr'} size={1}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CDNSVG name='fr_flag' />
      </Box>
    </Grid>
    <Grid hidden={lang !== 'en'} size={1}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CDNSVG name='gb_flag' />
      </Box>
    </Grid>
    <Grid hidden={lang !== 'nl'} size={1}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box width='23.99px' height='17.99px'>
          <Box height={1 / 3} bgcolor='red' />
          <Box height={1 / 3} bgcolor='white' />
          <Box height={1 / 3} bgcolor='blue' />
        </Box>
      </Box>
    </Grid>
    {_.map(translations, (elem, key) => <Grid key={key} rowSpacing={3} size="grow">
      <TextField
        name={`${elem.name}.${lang}`}
        label={index === 0 ? I18n.t(elem.labelKey) : null}
        emptyValue='-'
        multiline
        maxRows={2}
        required={elem.required}
        variant='standard'
        size='small' />
    </Grid>
    )}
  </Grid>

const Translation = ({ languages, ...rest }) => <Grid container rowSpacing={3}>
  {_.map(languages, (lang, index) =>
    <Row lang={lang} index={index} {...rest} key={index} />
  )}
</Grid>

export default Translation
